import { useAuth0 } from '../hooks/useAuth0'
import { Button } from '../components/common/Button'

/**
 * Login page for existing users
 */
export function Login() {
  const { loginWithRedirect } = useAuth0()

  const handleLogin = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'login', // Force Auth0 to show login screen, not signup
      },
      appState: {
        returnTo: '/dashboard',
      },
    })
  }

  const containerStyles = {
    minHeight: '100vh',
    background: 'linear-gradient(to bottom, #f0f9ff, #ffffff)',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  }

  const headerStyles = {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(8px)',
    borderBottom: '1px solid #f3f4f6',
    padding: '1rem 0',
    marginBottom: '2rem',
  }

  const headerContentStyles = {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  }

  const contentStyles = {
    maxWidth: '500px',
    margin: '0 auto',
    padding: '2rem 1rem',
    textAlign: 'center' as const,
  }

  const titleStyles = {
    fontSize: 'clamp(24px, 4vw, 32px)',
    fontWeight: 700,
    color: '#1a1a1a',
    marginBottom: '1rem',
  }

  const descriptionStyles = {
    fontSize: '16px',
    color: '#666',
    marginBottom: '2rem',
    lineHeight: 1.5,
  }

  return (
    <div style={containerStyles}>
      {/* Header */}
      <div style={headerStyles}>
        <div style={headerContentStyles}>
          <img
            src="/favicon.png"
            alt="Little Sister Logo"
            style={{
              height: '40px',
              width: '40px',
              objectFit: 'contain',
            }}
          />
          <span style={{ fontSize: '1.5rem', fontWeight: 700, color: '#111827' }}>
            Little Sister
          </span>
        </div>
      </div>

      {/* Content */}
      <div style={contentStyles}>
        <h1 style={titleStyles}>Welcome Back!</h1>
        <p style={descriptionStyles}>
          Log in to access your dashboard and manage your loved one's care.
        </p>
        <Button onClick={handleLogin} fullWidth>
          Log In
        </Button>
      </div>
    </div>
  )
}
